import {
  SET_ALBARANES,
  SET_CAMIONES,
  SET_OBRAS,
  SET_TIPOS,
  SET_VERTEDEROS,
  SET_ALBARAN_PENDIENTE,
  SET_CARTAS_PORTE,
  SET_CARTA_PORTE_PENDIENTE,
  SET_MAQUINAS,
  SET_PLANTAS_ARIDO,
} from "../types/app.types";

export const setAlbaranes = (payload = [], clearAlbaranPendiente = false) => ({
  type: SET_ALBARANES,
  payload,
  clearAlbaranPendiente,
});
export const setCamiones = (payload = []) => ({ type: SET_CAMIONES, payload });
export const setObras = (payload = []) => ({ type: SET_OBRAS, payload });
export const setTipos = (payload = []) => ({ type: SET_TIPOS, payload });
export const setVertederos = (payload = []) => ({
  type: SET_VERTEDEROS,
  payload,
});
export const setAlbaranPendiente = (payload = []) => ({
  type: SET_ALBARAN_PENDIENTE,
  payload,
});

// Cartas de Porte
export const setCartasPorte = (payload = [], clearCartaPendiente = false) => ({
  type: SET_CARTAS_PORTE,
  payload,
  clearCartaPendiente,
});

export const setCartaPortePendiente = (payload = null) => ({
  type: SET_CARTA_PORTE_PENDIENTE,
  payload,
});

export const setMaquinas = (payload = []) => ({
  type: SET_MAQUINAS,
  payload,
});

export const setPlantasArido = (payload = []) => ({
  type: SET_PLANTAS_ARIDO,
  payload,
});
